__turbopack_context__.v({
  "cardName": "comboResults-module-scss-module__lNfFgq__cardName",
  "comboResult": "comboResults-module-scss-module__lNfFgq__comboResult",
  "comboResultSection": "comboResults-module-scss-module__lNfFgq__comboResultSection",
  "comboResultsWrapper": "comboResults-module-scss-module__lNfFgq__comboResultsWrapper",
  "prerequisites": "comboResults-module-scss-module__lNfFgq__prerequisites",
  "variantBanner": "comboResults-module-scss-module__lNfFgq__variantBanner",
});
